module.exports = __webpack_public_path__ + "img/id.dabf6c06.png";